module.exports = __webpack_public_path__ + "static/media/pan-toss.dc810e06.png";